import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// eslint-disable-next-line import/no-extraneous-dependencies
import { TracewayProvider } from '@tracewayapp/react';
import packageJson from '../package.json';
//
import App from './App';

const TRACEWAY_CONNECTION_STRING = import.meta.env.PROD
  ? "1ef4cd4403d440888853651a71abf100@https://cloud.tracewayapp.com/api/report"
  : "frontend@http://localhost:8082/api/report";

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <TracewayProvider connectionString={TRACEWAY_CONNECTION_STRING} options={{ version: packageJson.version }}>
    <HelmetProvider>
      <BrowserRouter>
        <Suspense>
          <App />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </TracewayProvider>
);
